import {
    clearIndicator,
    control,
    dropdownIndicator,
    indicatorSeparator,
    input,
    menu,
    menuList,
    multiValue,
    multiValueRemove,
    multiValueLabel,
    option,
    placeholder,
    singleValue,
} from './styles';

const setStyle = (
    color,
    isClearable,
    colorToSelectedOption,
    fontWeight,
    border,
    fontColor,
    menuHeight,
    minWidth,
    whiteSpace,
    background,
    fontSize,
    fontFamily,
    display,
    justifyContent,
    margin,
    opacity,
    borderRadius,
) => ({
    clearIndicator: styles => clearIndicator(styles, color, fontColor),
    control: (styles, state) => control(
        styles, state, color, colorToSelectedOption, fontWeight, border, fontColor, background,
        fontSize, borderRadius,
    ),
    dropdownIndicator: (styles, state) => dropdownIndicator(
        styles, state, color, isClearable, fontColor,
    ),
    indicatorSeparator: (styles, state) => indicatorSeparator(styles, state),
    input: styles => input(styles, color, fontWeight, fontColor, fontFamily),
    menu: (styles, state) => menu(styles, state, fontWeight),
    menuList: (styles, state) => menuList(styles, state, menuHeight),
    option: (styles, state) => option(styles, state, fontColor, minWidth, whiteSpace),
    placeholder: (styles, state) => placeholder(styles, state, color, fontWeight,
        fontColor, fontFamily),
    singleValue: (styles, state) => singleValue(
        styles, state, color, colorToSelectedOption, fontWeight, fontColor, fontFamily,
        display, justifyContent, margin, opacity,
    ),
    multiValue: (styles, state) => multiValue(styles, state),
    multiValueLabel: (styles, state) => multiValueLabel(styles, state),
    multiValueRemove: (styles, state) => multiValueRemove(styles, state),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
});

export default setStyle;
